const NS = 'QuoteBlock';
const CLS = 'quoteBlock';
const WG = `.${CLS}-`;

export class QuoteBlock {
	constructor(element) {
		this.element = element;
		this.$element = $(element);

		this.$carousel = this.$element.find(`${WG}carousel`);
		console.log(this.$carousel);
		this.$carousel.slick({
			autoplay:true,
			autoplaySpeed:4000,
			dots: true
		});
	}
}